import CustomButton, { OutlinedButton } from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal";
import React, {useEffect} from "react";
import Input from "../../../components/form/Input";
import TextArea from "../../../components/form/TextArea";
import {ImageUploadCard} from "../../../components/ImageUploadCard";
import {useDispatch, useSelector} from "react-redux";
import {toKebabCase} from "../../../helpers/helperFunctions";
import {
  setBlogCreateData, setBlogTags,
  setManageBlogModals,
  tryAddNewBlog, tryUpdateBlogContents
} from "../../../redux/slices/manageBlogSlice";
import BlogTagList from "./BlogTagList";
import {TagsSearchSelect} from "../../../components/selects/TagsSearchSelect";
import {BLOG_STATE_ACTIVE} from "../constants";
import FormLabel from "components/form/FormLabel";

const BlogMetaDataModal = () => {

  const dispatch = useDispatch();
  const {loading: addingPages} = useSelector((state) => state.dynamicElements.editing);
  const addingTags = useSelector((state => state.manageBlogs.create.tag.loading));
  const {modal, data, ext: fromMainForm} = useSelector((state => state.manageBlogs.modals.form));
  const { seoDetails} = useSelector((state => state.manageBlogs.create.data));
  const title = useSelector((state => state.manageBlogs.create.mainTitle));


  const isAddForm = !data;


  useEffect(() => {
    if (!modal) {
      dispatch(setBlogCreateData({clear: true}));
      dispatch(setBlogTags({removeAll: true}));
    }

    if (!isAddForm) {

      dispatch(setBlogCreateData({
        ...(!fromMainForm && {title: data.title}),
        seoDetails: data.seo_details}));
      dispatch(setBlogTags({tags: data.tags}));
    }

  }, [modal]);


  const onSubmit = (publish = true) => {


    if (isAddForm) {
      dispatch(tryAddNewBlog({publish}));
    } else {
      dispatch(tryUpdateBlogContents({state: publish ? BLOG_STATE_ACTIVE : undefined}));
    }


  };

  const isAllFieldsValid = () => title.trim() &&
    seoDetails.title.trim() && seoDetails.description.trim() &&
    seoDetails.image && (!seoDetails.slug.trim() ||
      seoDetails.slug.trim().length > 2);

  const generateSlug = () => {
    if (seoDetails.title.length > 2) {
      dispatch(setBlogCreateData({seoDetails: {slug: toKebabCase(seoDetails.title)}}));
    }
  };

  return (<CustomModal
      title={
        <div>
          <span className="font-normal">[ {!data ? <span className="text-secondary-500">New</span> : 
          <span className={data.state === "DRAFT" ? "text-danger" : data.state === "INACTIVE" ? "text-neutral-darker" : "text-primary-500"}>{data.state}</span>
           } ]</span>
          {isAddForm ? " Add Meta Data to the Blog" : " Update Meta Data on Blog"}          
        </div>
      }
      showModal={modal}
      setShowModal={() => dispatch(setManageBlogModals())}
      loading={addingPages || addingTags}
      button={
        <>
          {data ? 
              <CustomButton onClick={() => onSubmit(false)} disabled={!isAllFieldsValid() || addingPages || addingTags}>
                Update
              </CustomButton>
            : 
              <OutlinedButton onClick={() => onSubmit(false)} disabled={!isAllFieldsValid() || addingPages || addingTags}>
                Save to Draft
              </OutlinedButton>
            }
          {
            data?.state !== BLOG_STATE_ACTIVE &&

            <CustomButton onClick={onSubmit}
                          disabled={!isAllFieldsValid() || addingPages || addingTags}>
              {!data ? "Publish" : "Update and Publish"}
            </CustomButton>

          }

        </>

      }
    >
      <div className="grid grid-cols-2 space-x-8">

        <div className="border-r pr-8 border-dashed">
          <div className="text-lg font-bold mb-6">Blog Details</div>
          {/* <Input
            label="Blog Title"
            className="flex-1"
            value={title}
            // onChange={(e) => dispatch(setBlogCreateData({title: e.target.value}))}
            onChange={()=>{}}
            // disabled={addingPages || fromMainForm}
            disabled={true}
          /> */}
          <FormLabel label="Blog Title"/>
          <div className="text-xl mb-6 font-light -mt-1">{title}</div>


          <div> 
            <TagsSearchSelect/>
            <BlogTagList/>
          </div>

        </div>
        <div>
          <div className="text-lg font-bold mb-6">SEO Details</div>
          <div className="flex flex-col">
            <div className="flex-1">
              <ImageUploadCard
                permanentRemove={false}
                initialImage={seoDetails.image}
                title="Meta Image"
                onImageUploaded={(image) => dispatch(setBlogCreateData({seoDetails: {image: image}}))}
                onImageRemoved={() => dispatch(setBlogCreateData({seoDetails: {image: ""}}))}

                disabled={addingPages}
              />
            </div>
            <div className="flex-1">
              <div className="flex items-center space-x-2">
                <Input
                  label="Title"
                  value={seoDetails.title}
                  onChange={(e) => dispatch(setBlogCreateData({seoDetails: {title: e.target.value}}))}

                  className="flex-1"
                  disabled={addingPages}
                />
                {isAddForm && <CustomButton className="whitespace-nowrap mt-1.5" onClick={generateSlug}
                                            disabled={seoDetails.title.trim().length < 3 || addingPages}>
                  Generate Slug
                </CustomButton>}
              </div>


              <TextArea
                label="Description"
                value={seoDetails.description}
                onChange={(e) => dispatch(setBlogCreateData({seoDetails: {description: e}}))}
                disabled={addingPages}
              />

              {(isAddForm) &&
                <>
                  <Input
                    label="Slug"
                    value={seoDetails.slug}
                    onChange={(e) => dispatch(setBlogCreateData({seoDetails: {slug: e.target.value}}))}
                    disabled={addingPages}
                    isRequired={false}
                    hideError={true}
                  />

                  <div className="text-sm"><strong>Note:</strong> You won't be able to edit slug later.</div>

                </>}
            </div>

          </div>
        </div>
      </div>
    </CustomModal>


  );
};

export default BlogMetaDataModal;
